import { render } from "./BrMessage.vue?vue&type=template&id=3e70c266&scoped=true"
import script from "./BrMessage.vue?vue&type=script&lang=js"
export * from "./BrMessage.vue?vue&type=script&lang=js"

import "./BrMessage.vue?vue&type=style&index=0&id=3e70c266&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e70c266"]])

export default __exports__